module.exports = "/images/garbage.svg";